import type { Ctx, CtxSpy } from '@reatom/framework';

import type { Observable } from './observable.ts';

export type Context = {
  spy: <T>(o: Observable<T>) => T;
};
export type ContextGet = {
  get: <T>(o: Observable<T>) => T;
};

export function createSpyContext(ctx: CtxSpy): Context {
  return {
    spy: (o) => ctx.spy(o.__INTERNAL_DO_NOT_USE_ATOM__),
  };
}

export function createGetContext(ctx: Ctx): ContextGet {
  return {
    get: (o) => ctx.get(o.__INTERNAL_DO_NOT_USE_ATOM__),
  };
}
